import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0%   { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

export const Box = styled.div`
  display: inline-block;
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '16px'};
  border-radius: ${(props) =>
    props.circle ? props.theme.radii.pill : props.theme.radii.sm};
  background: linear-gradient(
    90deg,
    ${(props) => props.theme.colors.surfaceMuted} 0px,
    ${(props) => props.theme.colors.lightgrey} 200px,
    ${(props) => props.theme.colors.surfaceMuted} 400px
  );
  background-size: 800px 100%;
  animation: ${shimmer} 1.2s linear infinite;
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.sm};
  width: 100%;
`;
